import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Bg from '../Medias/Photos/1649351195.jpg';

function SectionHeader({
  topic = '',
  detail = '',
  textAlign = 'bottom-0 start-0 text-start',
  textColor = 'text-white',
  bg = '',
  textSize = 5,
}) {
  return (
    <>
      <section
        className={`section-header position-relative font-header bg-img ${textColor}`}
        style={{ height: '30rem', backgroundImage: `url(${bg != '' ? bg : Bg})` }}
      >
        {/* <div className='position-absolute w-100 h-100 top-0 left-0' style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}></div> */}
        <div className='position-absolute w-100 h-100 top-0 left-0'
          style={{ background: `linear-gradient(to bottom, white, transparent)` }}
        ></div>
        <div className={`position-absolute w-100 ${textAlign}`}>
          <div className="fs-1 text-uppercase tx-spacing-30 mt-0 px-0 px-md-5">
            <Container className='px-5 pb-4' style={{ textShadow: '2px 2px 3px rgba(0, 0, 0, 0.6)' }}>
              <Row>
                <Col xs={12} md={10} className='px-0'>
                  <h3 className='font-header'>{topic}</h3>
                  <p style={{ fontSize: '18px', fontWeight: 'lighter', lineHeight: 1.3 }}>{detail}</p>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </>
  )
}

export default SectionHeader